<template>
    <div class="body">
        <div style="margin-bottom: 5rem;">
            <div style="text-align: center; font-size: 3rem; font-weight: bold; margin-bottom: 5rem;">
                辅助拉新
            </div>

            <van-button round size="large" type="warning" @click="helpRegister" style="height: 10rem; font-size: 3rem;">
                一键抢单
            </van-button>
        </div>

        <van-row>
            1、一键抢单如若无订单，请重新获取，直到有订单为止！
        </van-row>
        <van-row>
            2、微信扫码，按步骤做单完成即可。
        </van-row>
        <van-row>
            3、扫码微信注册需满半年，且开通了微信支付
        </van-row>
        <van-row>
            4、一个账号1年只能辅助3次，1个月1次！
        </van-row>

        <van-dialog v-model="dialogVisible" style="width: 80%;" @confirm="confirm">
            <p>
                请在五分钟内扫描二维码开始辅助拉新
            </p>
            <p v-if="amount > 0">佣金：{{amount}}</p>
            <p>
                <img src="http://fz.jisudui.net/Public/Uploads/alipay/fzzc3851.png"/>
            </p>
        </van-dialog>
    </div>
</template>

<script>
    import helpRegisterAPI from '@/api/helpRegister';

    export default {
        data() {
            return {
                query: {
                    traderId: this.$route.query.traderId,
                },
                dialogVisible: false,
                amount: 0,
            }
        },
        methods: {
            helpRegister() {
                if (!this.query.traderId) {
                    this.$toast("页面参数有误，请重新进入页面");
                    return;
                }
                this.$toast.loading({forbidClick: true});
                helpRegisterAPI.helpRegister(this.query).then((result) => {
                    this.$toast.clear();
                    this.amount = result.mng;
                    this.dialogVisible = true;
                }).catch(() => {
                });
            },
            confirm() {
                this.$router.go(0);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .all {
        background-color: #FFFFFF;
    }

    .body {
        padding: 2rem 2rem;
        line-height: 2.5rem;
        p {
            text-align: center;
            color: #000000;
        }
        img {
            height: 15rem;
            width: 15rem;
        }

    }

</style>
